module.exports = __webpack_public_path__ + "img/21.252a08a3.png";